import {
    Flex,
    Label,
    Avatar,
    useStyles,
    Grid,
    pxToRem,
    Button,
} from '@archipro-design/aria';
import { Divider } from './Divider';
import * as S from './ContactPage.desktop.style';
import type {
    ContactLoaderData,
    LocationDataType,
    ProfessionalInitialType,
} from '@modules/professional/type/contact-page-types';
import { MapPinLine } from '@archipro-design/icons';

import {
    getLocationSuburbText,
    getLocationProfessional,
} from '@modules/professional/util/contact-page-helper';
import { useLoaderData } from '@remix-run/react';

interface ItemProps {
    location: LocationDataType;
    professional: ProfessionalInitialType;
    onListItemClick: (location: LocationDataType) => void;
    onListItemHover: (location: LocationDataType) => void;
    isHovered?: boolean;
    isClicked?: boolean;
}

export const LocationListItem: React.FC<ItemProps> = ({
    location,
    professional,
    isHovered,
    isClicked,
    onListItemClick,
    onListItemHover,
}) => {
    const { css } = useStyles({ isHovered, isClicked });
    const loaderData = useLoaderData<ContactLoaderData>();
    const linkedProfiles =
        loaderData?.linkedProfiles as ContactLoaderData['linkedProfiles'];

    const locationProfessional = getLocationProfessional(
        location,
        professional,
        linkedProfiles
    );

    return (
        <>
            <Grid
                columns={`${pxToRem(72)} 1fr`}
                className={css(S.LocationListItem)}
                onClick={() => onListItemClick(location)}
                onMouseEnter={() => onListItemHover(location)}
            >
                <div>
                    <Avatar
                        image={{
                            src: locationProfessional.CompanyLogo ?? '',
                            alt: `${locationProfessional.Title} company logo`,
                        }}
                        size={72}
                        shape={'square'}
                        imageFit={'contain'}
                        variables={{
                            avatarImageBackgroundColor:
                                locationProfessional.LogoBackgroundColor,
                            borderWidth: '0',
                            avatarBackgroundColor: 'unset',
                        }}
                    />
                </div>
                <Grid columns={`1fr ${pxToRem(250)}`}>
                    <Grid columns={1}>
                        <Label weight="medium">{location.Title}</Label>
                        <Label>{getLocationSuburbText(location)}</Label>
                    </Grid>

                    <Flex
                        hAlign="end"
                        vAlign="center"
                        className={css(S.LocationActions)}
                    >
                        {location.distance && (
                            <Button
                                size={16}
                                transparent={true}
                                icon={<MapPinLine size="1x" />}
                                className={css(S.LocationListDistance)}
                            >
                                {`${location.distance} km`}
                            </Button>
                        )}

                        <Label
                            variant="02"
                            styles={{
                                textDecoration: 'underline',
                                textUnderlineOffset: pxToRem(2),
                            }}
                        >
                            View Location
                        </Label>
                    </Flex>
                </Grid>
            </Grid>
            <Divider />
        </>
    );
};
